import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SlImpersonateComponent } from '@sl/sl-angular-library';
import { HeaderComponent } from './shared/components/header/header.component';
import { LoadingComponent } from './shared/components/loading/loading.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterModule, LoadingComponent, HeaderComponent, SlImpersonateComponent]
})
export class AppComponent {

  constructor() { }

}